// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddWalletForm-addWalletWrapper-LZgKk {
    padding: 24px;
    border-radius: var(--radius-3);
    background-color: var(--background-primary);
}

.AddWalletForm-addWalletSectionTitle-VQZcb {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
    color: var(--primary-foreground);
    margin-bottom: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/AddWalletForm/AddWalletForm.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gCAAgC;IAChC,mBAAmB;IACnB,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAe;QAAf,eAAe;IACf,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,SAAS;AACb","sourcesContent":[".addWalletWrapper {\n    padding: 24px;\n    border-radius: var(--radius-3);\n    background-color: var(--background-primary);\n}\n\n.addWalletSectionTitle {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 30px;\n    color: var(--primary-foreground);\n    margin-bottom: 18px;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addWalletWrapper": `AddWalletForm-addWalletWrapper-LZgKk`,
	"addWalletSectionTitle": `AddWalletForm-addWalletSectionTitle-VQZcb`
};
module.exports = ___CSS_LOADER_EXPORT___;
